export default {
  PORTAL_RESULTS_END_REACHED: 'Portal results end reached',
  PORTAL_GRID_VIEW_CLICKED: 'Portal grid view clicked',
  PORTAL_LIST_VIEW_CLICKED: 'Portal list view clicked'
};
